import {
  Box,
  Card,
  CardBody,
  Center,
  Flex,
  Grid,
  Heading,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { Tilt } from "react-tilt";
import { motion } from "framer-motion";
import { fadeIn, textVariant } from "../utils/motions";
function TechSkill(props) {
  const imgList = [
    {
        img:"images/html.png",
        tag:'HTML',
        color:'#e44d26'
    },{
        img:"images/css.png",
        tag:'CSS',
        color:'#0277bd'
    },{
        img:"images/js.png",
        tag:'JavaScript',
        color:'#f4e11e'
    },{
        img:"images/react.png",
        tag:'React',
        color:'#00ccff'
    },{
        img:"images/redux.png",
        tag:'Redux',
        color:'#764eb9'
    },{
        img:"images/chakra.png",
        tag:'Chakra UI',
        color:'#4db6ac'
    },{
        img:"images/java.png",
        tag:'JAVA',
        color:'#f2ab49'
    },{
        img:"images/nodejs.png",
        tag:'Node JS',
        color:'#80bd01'
    },{
        img:"images/express.png",
        tag:'Express',
        color:'#393939'
    },{
        img:"images/mongodb.png",
        tag:'MongoDB',
        color:'#499d4a'
    },{
        img:"images/mssql.png",
        tag:'MS SQL',
        color:'#ee433d'
    },{
        img:"images/excel.png",
        tag:'MS Excel',
        color:'#1f7244'
    }
  ];
  
  return (
    <Box
     
      w={{ base: "95%", md: "80%" }} margin={"auto"}
      padding='5%'
      border={'solid #ffd3366b'}
      borderRadius='40px'
      id="skills"
    >
      <Stack textAlign={"left"} w="100%" margin={"auto"}>
        <Heading textAlign={"center"} mb={10} fontSize={30} color={"cpdark"}>
          Tech Skills
        </Heading>
        <Grid templateColumns={["repeat(2, 1fr)","repeat(2, 1fr)","repeat(3, 1fr)","repeat(4, 1fr)","repeat(6, 1fr)"]} gap={6}>
          {imgList.map((ele, index) => {
            return (
              <Tilt key={index}>
                <Card
                  bg={"#14213f"}
                  _hover={{
                    transition: "all 0.5s ease;",
                    bg: ele.color,
                  }}
                >
                  <CardBody margin={"auto"} textAlign='center' >
                    <Box
                      width={"80px"}
                      height={"80px"}
                      borderRadius={"50%"}
                      background={"#fff"}
                      border={"2px solid var(--bg-color)"}
                      display="flex"
                      justifyContent={"center"}
                      alignItems="center"
                      padding={3}
                      transition={"all 0.3s ease-out"}
                    >
                      <Image
                        src={ele.img}
                        alt="SUHAIL K"
                        fallbackSrc="https://via.placeholder.com/150"
                        objectFit={"fill"}
                      ></Image>
                    </Box>
                    <Text mt={5} color={"white"}>
                        {ele.tag}
                    </Text>
                  </CardBody>
                </Card>
              </Tilt>
            );
          })}
        </Grid>
      </Stack>
    </Box>
  );
}

export default TechSkill;
